import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':itemCategoryId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:itemCategoryId`;

export const URL = (itemCategoryId: number): RouteDefinition => `${baseRoute}/${itemCategoryId}`;
